module.exports = __webpack_public_path__ + "img/instagram.a19b822d.svg";